/**
 * Curated list of map-relevant FontAwesome Pro Solid icons
 * Organized by category for the icon picker
 * Aligned with CURATED_FA_ICONS from @wondermaps/db
 */

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  CURATED_FA_ICONS,
  type IconCategory as DbIconCategory,
} from "@wondermaps/db/client";
// Animals
import { faPaw } from "@fortawesome/pro-solid-svg-icons/faPaw";
import { faDog } from "@fortawesome/pro-solid-svg-icons/faDog";
import { faCat } from "@fortawesome/pro-solid-svg-icons/faCat";
import { faCrow } from "@fortawesome/pro-solid-svg-icons/faCrow";
import { faFish } from "@fortawesome/pro-solid-svg-icons/faFish";
import { faFishFins } from "@fortawesome/pro-solid-svg-icons/faFishFins";
import { faHorse } from "@fortawesome/pro-solid-svg-icons/faHorse";
import { faOtter } from "@fortawesome/pro-solid-svg-icons/faOtter";
import { faSpider } from "@fortawesome/pro-solid-svg-icons/faSpider";
import { faDove } from "@fortawesome/pro-solid-svg-icons/faDove";
import { faFrog } from "@fortawesome/pro-solid-svg-icons/faFrog";
import { faHippo } from "@fortawesome/pro-solid-svg-icons/faHippo";
import { faDragon } from "@fortawesome/pro-solid-svg-icons/faDragon";
import { faKiwiBird } from "@fortawesome/pro-solid-svg-icons/faKiwiBird";
import { faBug } from "@fortawesome/pro-solid-svg-icons/faBug";
import { faFeather } from "@fortawesome/pro-solid-svg-icons/faFeather";
import { faWhale } from "@fortawesome/pro-solid-svg-icons/faWhale";
import { faTurtle } from "@fortawesome/pro-solid-svg-icons/faTurtle";
import { faElephant } from "@fortawesome/pro-solid-svg-icons/faElephant";
import { faDeer } from "@fortawesome/pro-solid-svg-icons/faDeer";
import { faDuck } from "@fortawesome/pro-solid-svg-icons/faDuck";
import { faButterfly } from "@fortawesome/pro-solid-svg-icons/faButterfly";
import { faBee } from "@fortawesome/pro-solid-svg-icons/faBee";
import { faSquirrel } from "@fortawesome/pro-solid-svg-icons/faSquirrel";
import { faRabbit } from "@fortawesome/pro-solid-svg-icons/faRabbit";
import { faSnake } from "@fortawesome/pro-solid-svg-icons/faSnake";
import { faCrab } from "@fortawesome/pro-solid-svg-icons/faCrab";
import { faShrimp } from "@fortawesome/pro-solid-svg-icons/faShrimp";
import { faWorm } from "@fortawesome/pro-solid-svg-icons/faWorm";
import { faMosquito } from "@fortawesome/pro-solid-svg-icons/faMosquito";
// Nature
import { faTree } from "@fortawesome/pro-solid-svg-icons/faTree";
import { faTreePalm } from "@fortawesome/pro-solid-svg-icons/faTreePalm";
import { faLeaf } from "@fortawesome/pro-solid-svg-icons/faLeaf";
import { faLeafOak } from "@fortawesome/pro-solid-svg-icons/faLeafOak";
import { faLeafMaple } from "@fortawesome/pro-solid-svg-icons/faLeafMaple";
import { faFlower } from "@fortawesome/pro-solid-svg-icons/faFlower";
import { faFlowerTulip } from "@fortawesome/pro-solid-svg-icons/faFlowerTulip";
import { faSeedling } from "@fortawesome/pro-solid-svg-icons/faSeedling";
import { faMushroom } from "@fortawesome/pro-solid-svg-icons/faMushroom";
import { faCactus } from "@fortawesome/pro-solid-svg-icons/faCactus";
import { faMountain } from "@fortawesome/pro-solid-svg-icons/faMountain";
import { faMountainSun } from "@fortawesome/pro-solid-svg-icons/faMountainSun";
import { faWater } from "@fortawesome/pro-solid-svg-icons/faWater";
import { faSun } from "@fortawesome/pro-solid-svg-icons/faSun";
import { faCloud } from "@fortawesome/pro-solid-svg-icons/faCloud";
import { faCloudSun } from "@fortawesome/pro-solid-svg-icons/faCloudSun";
import { faCloudRain } from "@fortawesome/pro-solid-svg-icons/faCloudRain";
import { faSnowflake } from "@fortawesome/pro-solid-svg-icons/faSnowflake";
import { faWind } from "@fortawesome/pro-solid-svg-icons/faWind";
import { faFire } from "@fortawesome/pro-solid-svg-icons/faFire";
import { faVolcano } from "@fortawesome/pro-solid-svg-icons/faVolcano";
import { faRainbow } from "@fortawesome/pro-solid-svg-icons/faRainbow";
// Food
import { faUtensils } from "@fortawesome/pro-solid-svg-icons/faUtensils";
import { faBurger } from "@fortawesome/pro-solid-svg-icons/faBurger";
import { faPizzaSlice } from "@fortawesome/pro-solid-svg-icons/faPizzaSlice";
import { faIceCream } from "@fortawesome/pro-solid-svg-icons/faIceCream";
import { faCoffee } from "@fortawesome/pro-solid-svg-icons/faCoffee";
import { faMugHot } from "@fortawesome/pro-solid-svg-icons/faMugHot";
import { faMugSaucer } from "@fortawesome/pro-solid-svg-icons/faMugSaucer";
import { faCupStraw } from "@fortawesome/pro-solid-svg-icons/faCupStraw";
import { faWineGlass } from "@fortawesome/pro-solid-svg-icons/faWineGlass";
import { faBeerMugEmpty } from "@fortawesome/pro-solid-svg-icons/faBeerMugEmpty";
import { faMartiniGlass } from "@fortawesome/pro-solid-svg-icons/faMartiniGlass";
import { faCandyCane } from "@fortawesome/pro-solid-svg-icons/faCandyCane";
import { faCookie } from "@fortawesome/pro-solid-svg-icons/faCookie";
import { faCakeCandles } from "@fortawesome/pro-solid-svg-icons/faCakeCandles";
import { faAppleWhole } from "@fortawesome/pro-solid-svg-icons/faAppleWhole";
import { faCarrot } from "@fortawesome/pro-solid-svg-icons/faCarrot";
import { faHotdog } from "@fortawesome/pro-solid-svg-icons/faHotdog";
import { faTaco } from "@fortawesome/pro-solid-svg-icons/faTaco";
import { faBowlChopsticksNoodles } from "@fortawesome/pro-solid-svg-icons/faBowlChopsticksNoodles";
import { faPlateWheat } from "@fortawesome/pro-solid-svg-icons/faPlateWheat";
import { faEgg } from "@fortawesome/pro-solid-svg-icons/faEgg";
import { faBacon } from "@fortawesome/pro-solid-svg-icons/faBacon";
import { faCheese } from "@fortawesome/pro-solid-svg-icons/faCheese";
import { faPepperHot } from "@fortawesome/pro-solid-svg-icons/faPepperHot";
// Shopping
import { faStore } from "@fortawesome/pro-solid-svg-icons/faStore";
import { faShop } from "@fortawesome/pro-solid-svg-icons/faShop";
import { faBagShopping } from "@fortawesome/pro-solid-svg-icons/faBagShopping";
import { faCartShopping } from "@fortawesome/pro-solid-svg-icons/faCartShopping";
import { faBasketShopping } from "@fortawesome/pro-solid-svg-icons/faBasketShopping";
import { faGift } from "@fortawesome/pro-solid-svg-icons/faGift";
import { faShirt } from "@fortawesome/pro-solid-svg-icons/faShirt";
import { faHatCowboy } from "@fortawesome/pro-solid-svg-icons/faHatCowboy";
import { faGem } from "@fortawesome/pro-solid-svg-icons/faGem";
import { faTag } from "@fortawesome/pro-solid-svg-icons/faTag";
import { faReceipt } from "@fortawesome/pro-solid-svg-icons/faReceipt";
import { faBarcode } from "@fortawesome/pro-solid-svg-icons/faBarcode";
import { faShoePrints } from "@fortawesome/pro-solid-svg-icons/faShoePrints";
import { faRing } from "@fortawesome/pro-solid-svg-icons/faRing";
import { faScissors } from "@fortawesome/pro-solid-svg-icons/faScissors";
import { faDiamond } from "@fortawesome/pro-solid-svg-icons/faDiamond";
// Attractions
import { faStar } from "@fortawesome/pro-solid-svg-icons/faStar";
import { faWandMagicSparkles } from "@fortawesome/pro-solid-svg-icons/faWandMagicSparkles";
import { faMasksTheater } from "@fortawesome/pro-solid-svg-icons/faMasksTheater";
import { faCastle } from "@fortawesome/pro-solid-svg-icons/faCastle";
import { faFort } from "@fortawesome/pro-solid-svg-icons/faFort";
import { faMonument } from "@fortawesome/pro-solid-svg-icons/faMonument";
import { faArchway } from "@fortawesome/pro-solid-svg-icons/faArchway";
import { faBridge } from "@fortawesome/pro-solid-svg-icons/faBridge";
import { faBridgeSuspension } from "@fortawesome/pro-solid-svg-icons/faBridgeSuspension";
import { faLandmark } from "@fortawesome/pro-solid-svg-icons/faLandmark";
import { faTowerObservation } from "@fortawesome/pro-solid-svg-icons/faTowerObservation";
import { faPlaceOfWorship } from "@fortawesome/pro-solid-svg-icons/faPlaceOfWorship";
import { faGopuram } from "@fortawesome/pro-solid-svg-icons/faGopuram";
import { faToriiGate } from "@fortawesome/pro-solid-svg-icons/faToriiGate";
import { faChurch } from "@fortawesome/pro-solid-svg-icons/faChurch";
import { faMosque } from "@fortawesome/pro-solid-svg-icons/faMosque";
import { faSynagogue } from "@fortawesome/pro-solid-svg-icons/faSynagogue";
import { faVihara } from "@fortawesome/pro-solid-svg-icons/faVihara";
import { faKaaba } from "@fortawesome/pro-solid-svg-icons/faKaaba";
// Entertainment
import { faFerrisWheel } from "@fortawesome/pro-solid-svg-icons/faFerrisWheel";
import { faTicket } from "@fortawesome/pro-solid-svg-icons/faTicket";
import { faFilm } from "@fortawesome/pro-solid-svg-icons/faFilm";
import { faGamepad } from "@fortawesome/pro-solid-svg-icons/faGamepad";
import { faGamepadModern } from "@fortawesome/pro-solid-svg-icons/faGamepadModern";
import { faDice } from "@fortawesome/pro-solid-svg-icons/faDice";
import { faChess } from "@fortawesome/pro-solid-svg-icons/faChess";
import { faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons/faPuzzlePiece";
import { faMusic } from "@fortawesome/pro-solid-svg-icons/faMusic";
import { faGuitar } from "@fortawesome/pro-solid-svg-icons/faGuitar";
import { faDrum } from "@fortawesome/pro-solid-svg-icons/faDrum";
import { faMicrophone } from "@fortawesome/pro-solid-svg-icons/faMicrophone";
import { faMicrophoneStand } from "@fortawesome/pro-solid-svg-icons/faMicrophoneStand";
import { faHeadphones } from "@fortawesome/pro-solid-svg-icons/faHeadphones";
import { faCompactDisc } from "@fortawesome/pro-solid-svg-icons/faCompactDisc";
import { faRadio } from "@fortawesome/pro-solid-svg-icons/faRadio";
import { faTv } from "@fortawesome/pro-solid-svg-icons/faTv";
import { faVideo } from "@fortawesome/pro-solid-svg-icons/faVideo";
import { faPopcorn } from "@fortawesome/pro-solid-svg-icons/faPopcorn";
import { faClapperboard } from "@fortawesome/pro-solid-svg-icons/faClapperboard";
import { faBowlingBall } from "@fortawesome/pro-solid-svg-icons/faBowlingBall";
import { faTableTennisPaddleBall } from "@fortawesome/pro-solid-svg-icons/faTableTennisPaddleBall";
// Services
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { faBellConcierge } from "@fortawesome/pro-solid-svg-icons/faBellConcierge";
import { faCircleQuestion } from "@fortawesome/pro-solid-svg-icons/faCircleQuestion";
import { faPhone } from "@fortawesome/pro-solid-svg-icons/faPhone";
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import { faEnvelopeOpen } from "@fortawesome/pro-solid-svg-icons/faEnvelopeOpen";
import { faWifi } from "@fortawesome/pro-solid-svg-icons/faWifi";
import { faSignal } from "@fortawesome/pro-solid-svg-icons/faSignal";
import { faChargingStation } from "@fortawesome/pro-solid-svg-icons/faChargingStation";
import { faBolt } from "@fortawesome/pro-solid-svg-icons/faBolt";
import { faPlug } from "@fortawesome/pro-solid-svg-icons/faPlug";
import { faGear } from "@fortawesome/pro-solid-svg-icons/faGear";
import { faWrench } from "@fortawesome/pro-solid-svg-icons/faWrench";
import { faScrewdriverWrench } from "@fortawesome/pro-solid-svg-icons/faScrewdriverWrench";
import { faToolbox } from "@fortawesome/pro-solid-svg-icons/faToolbox";
import { faKey } from "@fortawesome/pro-solid-svg-icons/faKey";
import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { faLockOpen } from "@fortawesome/pro-solid-svg-icons/faLockOpen";
import { faShield } from "@fortawesome/pro-solid-svg-icons/faShield";
import { faShieldCheck } from "@fortawesome/pro-solid-svg-icons/faShieldCheck";
// Facilities
import { faRestroom } from "@fortawesome/pro-solid-svg-icons/faRestroom";
import { faToilet } from "@fortawesome/pro-solid-svg-icons/faToilet";
import { faToiletPortable } from "@fortawesome/pro-solid-svg-icons/faToiletPortable";
import { faBaby } from "@fortawesome/pro-solid-svg-icons/faBaby";
import { faBabyCarriage } from "@fortawesome/pro-solid-svg-icons/faBabyCarriage";
import { faPersonPregnant } from "@fortawesome/pro-solid-svg-icons/faPersonPregnant";
import { faWheelchair } from "@fortawesome/pro-solid-svg-icons/faWheelchair";
import { faEarDeaf } from "@fortawesome/pro-solid-svg-icons/faEarDeaf";
import { faHandsHoldingChild } from "@fortawesome/pro-solid-svg-icons/faHandsHoldingChild";
import { faElevator } from "@fortawesome/pro-solid-svg-icons/faElevator";
import { faEscalator } from "@fortawesome/pro-solid-svg-icons/faEscalator";
import { faStairs } from "@fortawesome/pro-solid-svg-icons/faStairs";
import { faDoorOpen } from "@fortawesome/pro-solid-svg-icons/faDoorOpen";
import { faShower } from "@fortawesome/pro-solid-svg-icons/faShower";
import { faFaucet } from "@fortawesome/pro-solid-svg-icons/faFaucet";
import { faSink } from "@fortawesome/pro-solid-svg-icons/faSink";
import { faHandHoldingDroplet } from "@fortawesome/pro-solid-svg-icons/faHandHoldingDroplet";
import { faBenchTree } from "@fortawesome/pro-solid-svg-icons/faBenchTree";
import { faLampStreet } from "@fortawesome/pro-solid-svg-icons/faLampStreet";
// Transportation
import { faCar } from "@fortawesome/pro-solid-svg-icons/faCar";
import { faCarSide } from "@fortawesome/pro-solid-svg-icons/faCarSide";
import { faBus } from "@fortawesome/pro-solid-svg-icons/faBus";
import { faBusSchool } from "@fortawesome/pro-solid-svg-icons/faBusSchool";
import { faTrain } from "@fortawesome/pro-solid-svg-icons/faTrain";
import { faTrainTram } from "@fortawesome/pro-solid-svg-icons/faTrainTram";
import { faTrainSubway } from "@fortawesome/pro-solid-svg-icons/faTrainSubway";
import { faTaxi } from "@fortawesome/pro-solid-svg-icons/faTaxi";
import { faBicycle } from "@fortawesome/pro-solid-svg-icons/faBicycle";
import { faMotorcycle } from "@fortawesome/pro-solid-svg-icons/faMotorcycle";
import { faScooter } from "@fortawesome/pro-solid-svg-icons/faScooter";
import { faCableCar } from "@fortawesome/pro-solid-svg-icons/faCableCar";
import { faShip } from "@fortawesome/pro-solid-svg-icons/faShip";
import { faFerry } from "@fortawesome/pro-solid-svg-icons/faFerry";
import { faSailboat } from "@fortawesome/pro-solid-svg-icons/faSailboat";
import { faPlane } from "@fortawesome/pro-solid-svg-icons/faPlane";
import { faHelicopter } from "@fortawesome/pro-solid-svg-icons/faHelicopter";
import { faJetFighter } from "@fortawesome/pro-solid-svg-icons/faJetFighter";
import { faRocket } from "@fortawesome/pro-solid-svg-icons/faRocket";
import { faParking } from "@fortawesome/pro-solid-svg-icons/faParking";
import { faGasPump } from "@fortawesome/pro-solid-svg-icons/faGasPump";
// Activities
import { faDumbbell } from "@fortawesome/pro-solid-svg-icons/faDumbbell";
import { faPersonWalking } from "@fortawesome/pro-solid-svg-icons/faPersonWalking";
import { faPersonRunning } from "@fortawesome/pro-solid-svg-icons/faPersonRunning";
import { faPersonSwimming } from "@fortawesome/pro-solid-svg-icons/faPersonSwimming";
import { faPersonHiking } from "@fortawesome/pro-solid-svg-icons/faPersonHiking";
import { faPersonBiking } from "@fortawesome/pro-solid-svg-icons/faPersonBiking";
import { faPersonSkiing } from "@fortawesome/pro-solid-svg-icons/faPersonSkiing";
import { faPersonSnowboarding } from "@fortawesome/pro-solid-svg-icons/faPersonSnowboarding";
import { faPersonSkating } from "@fortawesome/pro-solid-svg-icons/faPersonSkating";
import { faCampground } from "@fortawesome/pro-solid-svg-icons/faCampground";
import { faTent } from "@fortawesome/pro-solid-svg-icons/faTent";
import { faUmbrellaBeach } from "@fortawesome/pro-solid-svg-icons/faUmbrellaBeach";
import { faFishingRod } from "@fortawesome/pro-solid-svg-icons/faFishingRod";
import { faHorseSaddle } from "@fortawesome/pro-solid-svg-icons/faHorseSaddle";
import { faMedal } from "@fortawesome/pro-solid-svg-icons/faMedal";
import { faAward } from "@fortawesome/pro-solid-svg-icons/faAward";
// Safety
import { faKitMedical } from "@fortawesome/pro-solid-svg-icons/faKitMedical";
import { faSuitcaseMedical } from "@fortawesome/pro-solid-svg-icons/faSuitcaseMedical";
import { faFireExtinguisher } from "@fortawesome/pro-solid-svg-icons/faFireExtinguisher";
import { faLifeRing } from "@fortawesome/pro-solid-svg-icons/faLifeRing";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
// Finance
import { faDollarSign } from "@fortawesome/pro-solid-svg-icons/faDollarSign";
import { faCreditCard } from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import { faMoneyBill } from "@fortawesome/pro-solid-svg-icons/faMoneyBill";
import { faCoins } from "@fortawesome/pro-solid-svg-icons/faCoins";
import { faWallet } from "@fortawesome/pro-solid-svg-icons/faWallet";
import { faPiggyBank } from "@fortawesome/pro-solid-svg-icons/faPiggyBank";
import { faBuildingColumns } from "@fortawesome/pro-solid-svg-icons/faBuildingColumns";
import { faLandmarkDome } from "@fortawesome/pro-solid-svg-icons/faLandmarkDome";
import { faVault } from "@fortawesome/pro-solid-svg-icons/faVault";
import { faCashRegister } from "@fortawesome/pro-solid-svg-icons/faCashRegister";
// Amenities
import { faCouch } from "@fortawesome/pro-solid-svg-icons/faCouch";
import { faChair } from "@fortawesome/pro-solid-svg-icons/faChair";
import { faBed } from "@fortawesome/pro-solid-svg-icons/faBed";
import { faLamp } from "@fortawesome/pro-solid-svg-icons/faLamp";
import { faLightbulb } from "@fortawesome/pro-solid-svg-icons/faLightbulb";
import { faFan } from "@fortawesome/pro-solid-svg-icons/faFan";
import { faTrashCan } from "@fortawesome/pro-solid-svg-icons/faTrashCan";
import { faRecycle } from "@fortawesome/pro-solid-svg-icons/faRecycle";
import { faDumpster } from "@fortawesome/pro-solid-svg-icons/faDumpster";
import { faBox } from "@fortawesome/pro-solid-svg-icons/faBox";
import { faDroplet } from "@fortawesome/pro-solid-svg-icons/faDroplet";
import { faGlassWater } from "@fortawesome/pro-solid-svg-icons/faGlassWater";
import { faHouse } from "@fortawesome/pro-solid-svg-icons/faHouse";
// General
import { faPalette } from "@fortawesome/pro-solid-svg-icons/faPalette";
import { faCalendar } from "@fortawesome/pro-solid-svg-icons/faCalendar";
import { faLocationDot } from "@fortawesome/pro-solid-svg-icons/faLocationDot";
import { faMapPin } from "@fortawesome/pro-solid-svg-icons/faMapPin";
import { faFlag } from "@fortawesome/pro-solid-svg-icons/faFlag";
import { faBookmark } from "@fortawesome/pro-solid-svg-icons/faBookmark";
import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faSquare } from "@fortawesome/pro-solid-svg-icons/faSquare";
import { faHeart } from "@fortawesome/pro-solid-svg-icons/faHeart";
import { faThumbsUp } from "@fortawesome/pro-solid-svg-icons/faThumbsUp";
import { faEye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons/faMagnifyingGlass";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { faMinus } from "@fortawesome/pro-solid-svg-icons/faMinus";
import { faArrowsRotate } from "@fortawesome/pro-solid-svg-icons/faArrowsRotate";
// Medical
import { faStethoscope } from "@fortawesome/pro-solid-svg-icons/faStethoscope";
import { faPills } from "@fortawesome/pro-solid-svg-icons/faPills";
import { faHospital } from "@fortawesome/pro-solid-svg-icons/faHospital";
import { faSyringe } from "@fortawesome/pro-solid-svg-icons/faSyringe";
import { faHeartPulse } from "@fortawesome/pro-solid-svg-icons/faHeartPulse";
import { faBandage } from "@fortawesome/pro-solid-svg-icons/faBandage";
import { faDna } from "@fortawesome/pro-solid-svg-icons/faDna";
import { faXRay } from "@fortawesome/pro-solid-svg-icons/faXRay";
import { faBriefcaseMedical } from "@fortawesome/pro-solid-svg-icons/faBriefcaseMedical";
import { faHeadSideMask } from "@fortawesome/pro-solid-svg-icons/faHeadSideMask";
import { faAmbulance } from "@fortawesome/pro-solid-svg-icons/faAmbulance";
import { faLungs } from "@fortawesome/pro-solid-svg-icons/faLungs";
import { faVirusSlash } from "@fortawesome/pro-solid-svg-icons/faVirusSlash";
import { faMicroscope } from "@fortawesome/pro-solid-svg-icons/faMicroscope";
// Education
import { faGraduationCap } from "@fortawesome/pro-solid-svg-icons/faGraduationCap";
import { faBookOpenReader } from "@fortawesome/pro-solid-svg-icons/faBookOpenReader";
import { faSchool } from "@fortawesome/pro-solid-svg-icons/faSchool";
import { faUniversity } from "@fortawesome/pro-solid-svg-icons/faUniversity";
import { faChalkboard } from "@fortawesome/pro-solid-svg-icons/faChalkboard";
import { faChalkboardTeacher } from "@fortawesome/pro-solid-svg-icons/faChalkboardTeacher";
import { faLaptopCode } from "@fortawesome/pro-solid-svg-icons/faLaptopCode";
import { faAtom } from "@fortawesome/pro-solid-svg-icons/faAtom";
import { faPencilAlt } from "@fortawesome/pro-solid-svg-icons/faPencilAlt";
// Sports
import { faBaseball } from "@fortawesome/pro-solid-svg-icons/faBaseball";
import { faBaseballBatBall } from "@fortawesome/pro-solid-svg-icons/faBaseballBatBall";
import { faBasketball } from "@fortawesome/pro-solid-svg-icons/faBasketball";
import { faFootball } from "@fortawesome/pro-solid-svg-icons/faFootball";
import { faFutbol } from "@fortawesome/pro-solid-svg-icons/faFutbol";
import { faGolfBallTee } from "@fortawesome/pro-solid-svg-icons/faGolfBallTee";
import { faVolleyball } from "@fortawesome/pro-solid-svg-icons/faVolleyball";
import { faTennisBall } from "@fortawesome/pro-solid-svg-icons/faTennisBall";
import { faHockeyPuck } from "@fortawesome/pro-solid-svg-icons/faHockeyPuck";
import { faSwimmingPool } from "@fortawesome/pro-solid-svg-icons/faSwimmingPool";
// Buildings
import { faHotel } from "@fortawesome/pro-solid-svg-icons/faHotel";
import { faWarehouse } from "@fortawesome/pro-solid-svg-icons/faWarehouse";
import { faCabin } from "@fortawesome/pro-solid-svg-icons/faCabin";
import { faBuilding } from "@fortawesome/pro-solid-svg-icons/faBuilding";
import { faHouseChimney } from "@fortawesome/pro-solid-svg-icons/faHouseChimney";

// Re-export the icon category type from db
export type IconCategory = DbIconCategory;

export interface IconEntry {
  name: string;
  category: IconCategory;
  icon: IconDefinition;
}

// Map icon names to FA icon definitions
const iconMap: Record<string, IconDefinition> = {
  // Animals
  paw: faPaw,
  hippo: faHippo,
  otter: faOtter,
  fish: faFish,
  "fish-fins": faFishFins,
  dove: faDove,
  crow: faCrow,
  "kiwi-bird": faKiwiBird,
  dragon: faDragon,
  spider: faSpider,
  bug: faBug,
  frog: faFrog,
  cat: faCat,
  dog: faDog,
  horse: faHorse,
  feather: faFeather,
  whale: faWhale,
  turtle: faTurtle,
  elephant: faElephant,
  deer: faDeer,
  duck: faDuck,
  butterfly: faButterfly,
  bee: faBee,
  squirrel: faSquirrel,
  rabbit: faRabbit,
  snake: faSnake,
  crab: faCrab,
  shrimp: faShrimp,
  worm: faWorm,
  mosquito: faMosquito,

  // Nature
  tree: faTree,
  "tree-palm": faTreePalm,
  leaf: faLeaf,
  "leaf-oak": faLeafOak,
  "leaf-maple": faLeafMaple,
  flower: faFlower,
  "flower-tulip": faFlowerTulip,
  seedling: faSeedling,
  mushroom: faMushroom,
  cactus: faCactus,
  mountain: faMountain,
  "mountain-sun": faMountainSun,
  water: faWater,
  sun: faSun,
  cloud: faCloud,
  "cloud-sun": faCloudSun,
  "cloud-rain": faCloudRain,
  snowflake: faSnowflake,
  wind: faWind,
  fire: faFire,
  volcano: faVolcano,
  rainbow: faRainbow,

  // Food
  utensils: faUtensils,
  burger: faBurger,
  "pizza-slice": faPizzaSlice,
  "ice-cream": faIceCream,
  coffee: faCoffee,
  "mug-hot": faMugHot,
  "mug-saucer": faMugSaucer,
  "cup-straw": faCupStraw,
  "wine-glass": faWineGlass,
  "beer-mug-empty": faBeerMugEmpty,
  "martini-glass": faMartiniGlass,
  "candy-cane": faCandyCane,
  cookie: faCookie,
  "cake-candles": faCakeCandles,
  "apple-whole": faAppleWhole,
  carrot: faCarrot,
  hotdog: faHotdog,
  taco: faTaco,
  "bowl-chopsticks-noodles": faBowlChopsticksNoodles,
  "plate-wheat": faPlateWheat,
  egg: faEgg,
  bacon: faBacon,
  cheese: faCheese,
  "pepper-hot": faPepperHot,

  // Shopping
  store: faStore,
  shop: faShop,
  "bag-shopping": faBagShopping,
  "cart-shopping": faCartShopping,
  "basket-shopping": faBasketShopping,
  gift: faGift,
  shirt: faShirt,
  "hat-cowboy": faHatCowboy,
  gem: faGem,
  tag: faTag,
  receipt: faReceipt,
  barcode: faBarcode,
  "shoe-prints": faShoePrints,
  ring: faRing,
  scissors: faScissors,
  diamond: faDiamond,

  // Attractions
  star: faStar,
  "wand-magic-sparkles": faWandMagicSparkles,
  "masks-theater": faMasksTheater,
  castle: faCastle,
  fort: faFort,
  monument: faMonument,
  archway: faArchway,
  bridge: faBridge,
  "bridge-suspension": faBridgeSuspension,
  landmark: faLandmark,
  "tower-observation": faTowerObservation,
  "place-of-worship": faPlaceOfWorship,
  gopuram: faGopuram,
  "torii-gate": faToriiGate,
  church: faChurch,
  mosque: faMosque,
  synagogue: faSynagogue,
  vihara: faVihara,
  kaaba: faKaaba,

  // Entertainment
  "ferris-wheel": faFerrisWheel,
  ticket: faTicket,
  film: faFilm,
  gamepad: faGamepad,
  "gamepad-modern": faGamepadModern,
  dice: faDice,
  chess: faChess,
  "puzzle-piece": faPuzzlePiece,
  music: faMusic,
  guitar: faGuitar,
  drum: faDrum,
  microphone: faMicrophone,
  "microphone-stand": faMicrophoneStand,
  headphones: faHeadphones,
  "compact-disc": faCompactDisc,
  radio: faRadio,
  tv: faTv,
  video: faVideo,
  popcorn: faPopcorn,
  clapperboard: faClapperboard,
  "bowling-ball": faBowlingBall,
  "table-tennis-paddle-ball": faTableTennisPaddleBall,

  // Services
  "circle-info": faCircleInfo,
  "bell-concierge": faBellConcierge,
  "circle-question": faCircleQuestion,
  phone: faPhone,
  envelope: faEnvelope,
  "envelope-open": faEnvelopeOpen,
  wifi: faWifi,
  signal: faSignal,
  "charging-station": faChargingStation,
  bolt: faBolt,
  plug: faPlug,
  gear: faGear,
  wrench: faWrench,
  "screwdriver-wrench": faScrewdriverWrench,
  toolbox: faToolbox,
  key: faKey,
  lock: faLock,
  "lock-open": faLockOpen,
  shield: faShield,
  "shield-check": faShieldCheck,

  // Facilities
  restroom: faRestroom,
  toilet: faToilet,
  "toilet-portable": faToiletPortable,
  home: faHouse,
  baby: faBaby,
  "baby-carriage": faBabyCarriage,
  "person-pregnant": faPersonPregnant,
  wheelchair: faWheelchair,
  "ear-deaf": faEarDeaf,
  "hands-holding-child": faHandsHoldingChild,
  elevator: faElevator,
  escalator: faEscalator,
  stairs: faStairs,
  "door-open": faDoorOpen,
  shower: faShower,
  faucet: faFaucet,
  sink: faSink,
  "hand-holding-droplet": faHandHoldingDroplet,
  "bench-tree": faBenchTree,
  "lamp-street": faLampStreet,

  // Transportation
  car: faCar,
  "car-side": faCarSide,
  bus: faBus,
  "bus-school": faBusSchool,
  train: faTrain,
  "train-tram": faTrainTram,
  subway: faTrainSubway,
  taxi: faTaxi,
  bicycle: faBicycle,
  motorcycle: faMotorcycle,
  scooter: faScooter,
  "cable-car": faCableCar,
  ship: faShip,
  ferry: faFerry,
  sailboat: faSailboat,
  plane: faPlane,
  helicopter: faHelicopter,
  "jet-fighter": faJetFighter,
  rocket: faRocket,
  parking: faParking,
  "gas-pump": faGasPump,

  // Activities
  dumbbell: faDumbbell,
  "person-walking": faPersonWalking,
  "person-running": faPersonRunning,
  "person-swimming": faPersonSwimming,
  "person-hiking": faPersonHiking,
  "person-biking": faPersonBiking,
  "person-skiing": faPersonSkiing,
  "person-snowboarding": faPersonSnowboarding,
  "person-skating": faPersonSkating,
  campground: faCampground,
  tent: faTent,
  "umbrella-beach": faUmbrellaBeach,
  "fishing-rod": faFishingRod,
  "horse-saddle": faHorseSaddle,
  medal: faMedal,
  award: faAward,

  // Safety
  "kit-medical": faKitMedical,
  "suitcase-medical": faSuitcaseMedical,
  "fire-extinguisher": faFireExtinguisher,
  "life-ring": faLifeRing,
  "triangle-exclamation": faTriangleExclamation,

  // Finance
  "dollar-sign": faDollarSign,
  "credit-card": faCreditCard,
  "money-bill": faMoneyBill,
  coins: faCoins,
  wallet: faWallet,
  "piggy-bank": faPiggyBank,
  "building-columns": faBuildingColumns,
  "landmark-dome": faLandmarkDome,
  vault: faVault,
  "cash-register": faCashRegister,

  // Amenities
  couch: faCouch,
  chair: faChair,
  bed: faBed,
  lamp: faLamp,
  lightbulb: faLightbulb,
  fan: faFan,
  "trash-can": faTrashCan,
  recycle: faRecycle,
  dumpster: faDumpster,
  box: faBox,
  droplet: faDroplet,
  "glass-water": faGlassWater,

  // General
  palette: faPalette,
  calendar: faCalendar,
  "location-dot": faLocationDot,
  "map-pin": faMapPin,
  flag: faFlag,
  bookmark: faBookmark,
  circle: faCircle,
  square: faSquare,
  heart: faHeart,
  "thumbs-up": faThumbsUp,
  eye: faEye,
  "magnifying-glass": faMagnifyingGlass,
  check: faCheck,
  xmark: faXmark,
  plus: faPlus,
  minus: faMinus,
  "arrows-rotate": faArrowsRotate,

  // Medical
  stethoscope: faStethoscope,
  pills: faPills,
  hospital: faHospital,
  syringe: faSyringe,
  "heart-pulse": faHeartPulse,
  bandage: faBandage,
  dna: faDna,
  "x-ray": faXRay,
  "briefcase-medical": faBriefcaseMedical,
  "head-side-mask": faHeadSideMask,
  ambulance: faAmbulance,
  lungs: faLungs,
  "virus-slash": faVirusSlash,
  microscope: faMicroscope,

  // Education
  "graduation-cap": faGraduationCap,
  "book-open-reader": faBookOpenReader,
  school: faSchool,
  university: faUniversity,
  chalkboard: faChalkboard,
  "chalkboard-teacher": faChalkboardTeacher,
  "laptop-code": faLaptopCode,
  atom: faAtom,
  "pencil-alt": faPencilAlt,

  // Sports
  baseball: faBaseball,
  "baseball-bat-ball": faBaseballBatBall,
  basketball: faBasketball,
  football: faFootball,
  futbol: faFutbol,
  "golf-ball-tee": faGolfBallTee,
  volleyball: faVolleyball,
  "tennis-ball": faTennisBall,
  "hockey-puck": faHockeyPuck,
  "swimming-pool": faSwimmingPool,

  // Buildings
  hotel: faHotel,
  warehouse: faWarehouse,
  cabin: faCabin,
  building: faBuilding,
  "house-chimney": faHouseChimney,

  // Backward-compat aliases (old names still in production POI data)
  "shopping-bag": faBagShopping,
  "info-circle": faCircleInfo,
  "question-circle": faCircleQuestion,
  "gamepad-2": faGamepadModern,
  "flower-2": faFlower,
  bench: faBenchTree,
  droplets: faDroplet,
  atm: faBuildingColumns,
};

// Build FONTAWESOME_ICONS from CURATED_FA_ICONS (deduplicated by name)
const seen = new Set<string>();
export const FONTAWESOME_ICONS: IconEntry[] = Object.entries(CURATED_FA_ICONS)
  .flatMap(([category, icons]) =>
    icons.map((iconName) => {
      if (seen.has(iconName)) return null;
      seen.add(iconName);
      const icon = iconMap[iconName];
      if (!icon) {
        console.warn(`Missing icon definition for: ${iconName}`);
        return null;
      }
      return {
        name: iconName as string,
        category: category as IconCategory,
        icon,
      };
    })
  )
  .filter((entry): entry is IconEntry => entry !== null);

// O(1) lookup map for findIconByName
const iconEntryMap = new Map<string, IconEntry>(
  FONTAWESOME_ICONS.map((entry) => [entry.name, entry])
);

// Set of all curated icon names (used by FontAwesomeIconPicker to exclude from fas results)
export const CURATED_NAMES = new Set(FONTAWESOME_ICONS.map((i) => i.name));

// Helper to find icon by name (checks curated list first, then full iconMap + runtime registry)
export function findIconByName(name: string): IconEntry | undefined {
  const curated = iconEntryMap.get(name);
  if (curated) return curated;
  // Fallback: icon exists in iconMap or runtime registry but isn't in curated list
  const def = iconMap[name] ?? runtimeIconRegistry[name];
  if (def) return { name, category: "general" as IconCategory, icon: def };
  return undefined;
}

/**
 * Runtime registry for non-curated icons selected via theme editor.
 * Allows getFontAwesomeSvgData to resolve icons without importing the full fas library.
 */
const runtimeIconRegistry: Record<string, IconDefinition> = {};

/**
 * Register a non-curated icon definition so the rendering pipeline can resolve it.
 * Called by the theme editor when a non-curated icon is selected.
 */
export function registerIcon(name: string, icon: IconDefinition): void {
  runtimeIconRegistry[name] = icon;
}

/**
 * Get icon definition from the curated iconMap or runtime registry by name.
 */
export function getIconDefinition(
  iconName: string
): IconDefinition | undefined {
  return iconMap[iconName] ?? runtimeIconRegistry[iconName];
}

/**
 * Extract SVG path data from a FontAwesome icon for use with canvas rendering.
 * Checks curated iconMap first, then runtime registry for non-curated icons.
 * FontAwesome icon format: [width, height, ligatures, unicode, svgPathData]
 */
export function getFontAwesomeSvgData(
  iconName: string
): { path: string; viewBox: string } | null {
  const icon = iconMap[iconName] ?? runtimeIconRegistry[iconName];
  if (!icon) return null;

  const [width, height, , , pathData] = icon.icon;
  const path = Array.isArray(pathData) ? pathData.join(" ") : pathData;

  return {
    path,
    viewBox: `0 0 ${width} ${height}`,
  };
}

/** Convert kebab-case icon name to FA PascalCase key (e.g. "castle" → "faCastle") */
export function kebabToFaKey(name: string): string {
  return (
    "fa" +
    name
      .split("-")
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
      .join("")
  );
}

/** Convert FA PascalCase key to kebab-case icon name (e.g. "faCastle" → "castle") */
export function faKeyToKebab(faName: string): string {
  const stripped = faName.startsWith("fa") ? faName.slice(2) : faName;
  return stripped.replace(/([A-Z])/g, (_m, c, i) => (i > 0 ? "-" : "") + c.toLowerCase());
}

/**
 * Resolve and register non-curated icon names from a theme config.
 * Lazy-loads fas only if needed. Called by usePoiMarkers before rendering.
 */
export async function registerThemeIcons(iconNames: string[]): Promise<void> {
  const unresolved = iconNames.filter(
    (name) => !iconMap[name] && !runtimeIconRegistry[name]
  );
  if (unresolved.length === 0) return;

  const { loadFas } = await import("./fontawesome-fas-loader");
  const fasMap = await loadFas();

  for (const name of unresolved) {
    const def = fasMap[kebabToFaKey(name)];
    if (def) {
      runtimeIconRegistry[name] = def;
    }
  }
}

// All categories - derived from CURATED_FA_ICONS keys
export const ICON_CATEGORIES = Object.keys(CURATED_FA_ICONS) as IconCategory[];
